import React from "react"
//import * as styles from "./Address.module.scss"

type PostalAddressProps = {
  postOfficeBoxNumber?: string | null
  streetAddress?: string | null
  postalCode?: string | null
  addressLocality?: string | null
  addressRegion?: string | null
  addressCountry?: string | null
  labelPrefixPo?: string
}

const PostalAddress = (props: PostalAddressProps) => {
  // console.log("Rendering Address", data)

  return (
    <p itemScope itemType="https://schema.org/PostalAddress">
      {[
        props.postOfficeBoxNumber && props.labelPrefixPo
          ? `${props.labelPrefixPo} ${props.postOfficeBoxNumber}`
          : props.postOfficeBoxNumber,
        props.streetAddress,
        [props.postalCode, props.addressLocality].filter(i => i).join(" "),
        [props.addressRegion, props.addressCountry?.toUpperCase()].filter(i => i).join(", "),
      ]
        .filter(i => i)
        .join("\n")}
    </p>
  )
}

export default PostalAddress
